export default __webpack_public_path__ + "static/media/avatar_blue.12343270.svg";